import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DtpContentContainer, DtpButton } from 'dtp-react-components';
import { connect } from 'react-redux';
import {
  Table,
  Grid,
  Button,
} from '../../components/index';
import {
  doGet,
  doDelete,
  trataMensagemSucesso,
  trataMensagensErro,
  doPut,
  buscaDestinatarios,
} from '../../utils/requests';
import * as listUtils from '../../utils/listsSelect';
import FiltroRepositorioCtc from './FiltroRepositorioCtc';
import ModalAlerta from '../requerimentos/ModalAlerta';
import {
  msgConfirmacaoCtc,
} from '../../utils/constants';

const TAMANHO_MAX_COLECAO_COM_UMA_MATRICULA = 2;
const TAMANHO_MAX_COLECAO_COM_DUAS_MATRICULAS = 3;
const VAZIO = '';
const SITUACAO_CTC_ATIVA = 'ativa';
const SITUACAO_CTC_INATIVA = 'inativa';
const SITUACAO_RASCUNHO = 'rascunho';

class ConsultaRepositorioCtc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaCtcsFiltrada: null,
      listaCtcsIndexada: [],
      showNoContent: false,
      listaCtcsIndexadaAtualizada: false,
      estadoTabela: {
        quantidadeTotalResultados: 0,
        resultadosPorPagina: 5,
        paginaAtual: 1,
      },
      filtrosPesquisa: {},
      cpf: null,
      nome: null,
      titulo: 'Certidões de Tempo de Contribuição ',
      showModalAlerta: false,
      showModalAlertaInvalidacao: false,
      protocoloComprev: null,
      estadoConsulta: 'inicial',
    };
  }

  componentDidMount() {
    if (this.props.destinatarios.length === 0) {
      buscaDestinatarios(this.handleErrorBuscaCtc);
    }
    if (['ctc'].includes(this.props.match.params.tipoConsulta) && !sessionStorage.getItem('filtroRepositorioCtc')) {
      this.realizaConsulta();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.tipoConsulta !== prevProps.match.params.tipoConsulta) {
      this.preparaNovaConsulta();
    }
  }

  getTipoConsulta = () => (
    this.props.match.params.tipoConsulta
  )

  preparaNovaConsulta = () => {
    const estadoTabela = {
      quantidadeTotalResultados: 0,
      resultadosPorPagina: 10,
      paginaAtual: 1,
    };
    this.setState({
      listaCtcsFiltrada: null,
      estadoTabela,
    }, this.realizaConsulta());
  }

  realizaConsulta = (filtrosPesquisa) => {
    let filtrosConsulta = {};
    if (filtrosPesquisa) {
      filtrosConsulta = this.montaFiltros(filtrosPesquisa);
    }

    this.setState({ ...this.state, filtrosConsulta, titulo: 'Certidões de Tempo de Contribuição ' }, this.executaConsulta);
  }

  executaConsulta = () => {
    if (Object.entries(this.state.filtrosConsulta).length !== 0) {
      const { resultadosPorPagina } = { ...this.state.estadoTabela };
      const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
      if (this.props.auth.checkPermission(['analisar-compensacao-rpps'])) {
        doGet(
          'ctc/consulta/cpf',
          this.tratarSucesso,
          this.tratarErro,
          {
            ...this.state.filtrosConsulta,
            'start-position': primeiroItem,
            'max-results': resultadosPorPagina,
          },
        );
      }
    } else {
      this.setState({ listaCtcsIndexada: [], listaCtcsIndexadaAtualizada: true });
    }
  }

  montaFiltros = (atributosPesquisa) => {
    let atributos = {
      versaoAtiva: atributosPesquisa.versaoAtiva,
    };

    if (atributosPesquisa.cpf) {
      atributos = { ...atributos, cpf: atributosPesquisa.cpf };
    }

    const { resultadosPorPagina } = { ...this.state.estadoTabela };
    if (atributosPesquisa.cliqueiNoBotao === 1) {
      this.state.estadoTabela.paginaAtual = 1;
    }
    const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
    atributos = { ...atributos, 'max-results': resultadosPorPagina };
    atributos = { ...atributos, 'start-position': primeiroItem };

    return atributos;
  }

  tratarSucesso = (response) => {
    let quantidadeTotalResultados = 0;
    if (response.headers['content-range']) {
      const { headers } = { ...response };
      // eslint-disable-next-line
      quantidadeTotalResultados = headers['content-range'].split('/')[1];
    }
    const { estadoTabela } = { ...this.state };
    estadoTabela.quantidadeTotalResultados = quantidadeTotalResultados;
    if (response.data === '' || response.data.length === 0) {
      this.setState({
        showNoContent: false,
        listaCtcsIndexada: [],
        listaCtcsIndexadaAtualizada: true,
        estadoTabela,
        estadoConsulta: 'consulta-executada',
      });
    } else {
      this.setState({
        showNoContent: false,
        listaCtcsIndexada: response.data,
        listaCtcsIndexadaAtualizada: true,
        estadoTabela,
        estadoConsulta: 'consulta-executada',
        // titulo: tituloTabela,
      });
    }
  };

  /**
   * Trata filtros na lista que veio do servidor (Componente FiltroPesquisa)
   */
  tratarFiltroNaLista = (listaCtcsFiltrada) => {
    this.setState({ listaCtcsFiltrada, listaCtcsIndexadaAtualizada: false });
  }

  tratarErro = (error) => {
    if (error) {
      const { data } = { ...error };
      if (error.status) {
        if (error.status === 404) {
          this.setState({
            showNoContent: true,
            noContentPrimaryMessage: 'CTC não encontrada para o cpf informado.',
            noContentSecondaryMessage: 'Informe um protocolo válido.',
          });
        } else {
          this.setState({
            showNoContent: true,
            noContentPrimaryMessage: `${data.mensagem}`,
            noContentSecondaryMessage: `${data.descricao}`,
            listaCtcsIndexada: [],
            listaCtcsIndexadaAtualizada: true,
          });
        }
      } else {
        this.setState({
          showNoContent: true,
          noContentPrimaryMessage: 'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',
          noContentSecondaryMessage: 'Tente novamente mais tarde.',
        });
      }
    }
  }

  handleChange = (e, name) => {
    this.setState({
      ...this.state,
      [name]: e,
    });
  }

  createColunaMatricula = (cell, row) => {
    const temMatricula1 = (row.matricula1 !== null && row.matricula1 !== VAZIO);
    const temMatricula2 = (row.matricula2 !== null && row.matricula2 !== VAZIO);

    const matricula1 = temMatricula1 ? (
      <Grid cols="12 12 12 12" style={{ 'text-align': 'justify' }}>
        <span style={{ 'text-align': 'justify', color: 'blue' }}>1.&nbsp;</span>{row.matricula1}
      </Grid>
    ) : null;
    const matricula2 = temMatricula2 ? (
      <Grid cols="12 12 12 12" style={{ 'text-align': 'justify' }}>
        <span style={{ 'text-align': 'justify', color: 'blue' }}>2.&nbsp;</span>{row.matricula2}
      </Grid>
    ) : null;
    // style={{ 'text-align': 'justify' }}
    return (
      <React.Fragment>
        <div>
          {matricula1}
          {matricula2}
        </div>
      </React.Fragment>
    );
  };

  createColunaDestinatarios = (cell, row) => {
    const tamanho = row.destinacoes ? row.destinacoes.length : 0;
    let possuiDestinatario1 = false;
    let possuiDestinatario2 = false;
    let possuiDestinatario3 = false;

    switch (tamanho) {
      case 1:
        possuiDestinatario1 = true;
        break;
      case 2:
        possuiDestinatario1 = true;
        possuiDestinatario2 = true;
        break;
      case 3:
        possuiDestinatario1 = true;
        possuiDestinatario2 = true;
        possuiDestinatario3 = true;
        break;
      default:
        break;
    }

    const destinatario1 = possuiDestinatario1 ? (
      <Grid cols="12 12 12 12" style={{ 'text-align': 'justify' }}>
        <span style={{ color: 'blue' }}>1.&nbsp;</span>{row.destinacoes[0].nomeOrgao} - {row.destinacoes[0].codigoParticipante}
      </Grid>
    ) : null;
    const destinatario2 = possuiDestinatario2 ? (
      <Grid cols="12 12 12 12" style={{ 'text-align': 'justify' }}>
        <span style={{ color: 'blue' }}>2.&nbsp;</span>{row.destinacoes[1].nomeOrgao} - {row.destinacoes[1].codigoParticipante}
      </Grid>
    ) : null;
    const destinatario3 = possuiDestinatario3 ? (
      <Grid cols="12 12 12 12" style={{ 'text-align': 'justify' }}>
        <span style={{ color: 'blue' }}>3.&nbsp;</span>{row.destinacoes[2].nomeOrgao} - {row.destinacoes[2].codigoParticipante}
      </Grid>
    ) : null;
    // style={{ 'text-align': 'justify' }}
    return (
      <React.Fragment>
        <div>
          {destinatario1}
          {destinatario2}
          {destinatario3}
        </div>
      </React.Fragment>
    );
  };

  verificarSituacao = (row) => {
    let situacao = '';
    if (row.versaoAtiva === 0 && row.dtInvalidacao === null) {
      situacao = SITUACAO_RASCUNHO;
    } else if (row.versaoAtiva === 0 && row.dtInvalidacao !== null) {
      situacao = SITUACAO_CTC_INATIVA;
    } else if (row.versaoAtiva === 1 && row.dtInvalidacao === null) {
      situacao = SITUACAO_CTC_ATIVA;
    }
    return situacao;
  }

  addTipoSituacaoCtcLabel = (cell, row) => {
    let situacao = '';
    let situacaoCss = '';
    if (row.versaoAtiva === 0 && row.dtInvalidacao === null) {
      situacao = 'Rascunho';
      situacaoCss = 'situacaoCtcRascunho';
    } else if (row.versaoAtiva === 0 && row.dtInvalidacao !== null) {
      situacao = 'Inativa';
      situacaoCss = 'situacaoCtcInativa';
    } else if (row.versaoAtiva === 1 && row.dtInvalidacao === null) {
      situacao = 'Ativa';
      situacaoCss = 'situacaoCtcAtiva';
    }

    return (
      <React.Fragment>
        {(<div className={situacaoCss}>{situacao}</div>)}
      </React.Fragment>
    );
  };

  showCadastroCtcEdicao = (ctc) => {
    this.props.history.push(`/repositorioctc/rpps/${ctc.cpf}/editar-rascunho`);
  }

  showDetalharCtc = (ctc, situacao) => {
    // DETALHAR É CARREGAR A TELA COM TODOS OS CAMPOS DESABILITADOS.
    this.props.history.push(`/repositorioctc/rpps/${ctc.protocoloComprev}/${situacao}/detalhar-ctc`);
  }

  showDetalharCtcInvalida = (ctc) => {
    // DETALHAR É CARREGAR A TELA COM TODOS OS CAMPOS DESABILITADOS.
    this.props.history.push(`/repositorioctc/rpps/${ctc.protocoloComprev}/detalhar-ctc-invalida`);
  }

  showCadastroCtcRevisao = (ctc) => {
    this.props.history.push(`/repositorioctc/rpps/${ctc.protocoloComprev}/revisar-ctc`);
  }

  redirecionaRequest = (row) => {
    const situacao = this.verificarSituacao(row);
    if (['rascunho', 'ativa'].includes(situacao)) {
      return () => this.showDetalharCtc(row, situacao);
    }
    return () => this.showDetalharCtcInvalida(row);
  }

  montaAcoesCTC = (cell, row) => {
    const isRascunho = (row.versaoAtiva === 0 && row.dtInvalidacao === null);
    const acaoEditarRascunho = isRascunho;
    const acaoApagarRascunho = isRascunho;
    const acaoInvalidarCtc = row.versaoAtiva === 1;
    const acaoRevisarCtc = row.versaoAtiva === 1;

    const botaoEditarRacunho = acaoEditarRascunho ? (
      <Button
        hint="Editar rascunho"
        icon="ico-pencil"
        mini
        onClick={() => this.showCadastroCtcEdicao(row)}
      />
    ) : '';
    const botaoApagarRascunho = acaoApagarRascunho ? (
      <Button
        hint="Apagar rascunho"
        icon="ico-trash-can"
        mini
        className="dtp-inverse"
        onClick={() => this.exibirModalAlertaRascunho(row)}
      />
    ) : '';
    const botaoInvalidarCtc = acaoInvalidarCtc ? (
      <Button
        hint="Invalidar CTC"
        icon="ico-doc-thumb-down"
        mini
        className="dtp-inverse"
        onClick={() => this.exibirModalAlertaInvalidarCtc(row)}
      />
    ) : '';
    const botaoRevisarCtc = acaoRevisarCtc ? (
      <Button
        hint="Revisar CTC"
        icon="ico-clipboard-search"
        mini
        onClick={() => this.showCadastroCtcRevisao(row)}
      />
    ) : '';
    const botaoDetalharCtc = (
      <Button
        hint={isRascunho ? 'Detalhar Rascunho' : 'Detalhar CTC'}
        icon="ico-magnifier"
        mini
        onClick={this.redirecionaRequest(row)}
      />
    );
    return (
      <React.Fragment>
        { botaoEditarRacunho }
        { botaoApagarRascunho }
        { botaoRevisarCtc }
        { botaoInvalidarCtc }
        { botaoDetalharCtc }
      </React.Fragment>
    );
  }

  colunasDefault = [
    {
      id: 'protocoloEmissor',
      label: 'Protocolo CTC',
      // width: '15%',
    },
    {
      id: 'matricula',
      label: 'Matrícula',
      // width: '10%',
      dataFormat: this.createColunaMatricula,
    },
    {
      id: 'destinacao',
      label: 'Destinatário',
      // width: '25%',
      dataFormat: this.createColunaDestinatarios,
    },
  ];
  colunasConsultaSemParametros = [
    {
      id: 'nome',
      label: 'Nome',
      // width: '20%',
    },
  ];

  montaColunas = () => {
    let tableHeader = this.colunasDefault.slice();
    let colunasEspecificas = [];
    if (this.state.filtrosConsulta && this.state.filtrosConsulta.cpf === undefined) {
      tableHeader = tableHeader.concat(this.colunasConsultaSemParametros);
    }
    // exibir a versao para as ctc inativas
    if (this.state.filtrosConsulta && this.state.filtrosConsulta.versaoAtiva === 0) {
      colunasEspecificas = this.montaColunasEspecificasVersao();
    }
    if (colunasEspecificas) {
      tableHeader = tableHeader.concat(colunasEspecificas);
    }
    tableHeader.push(
      {
        id: 'versaoAtiva',
        label: 'Situação',
        // width: '6%',
        dataFormat: this.addTipoSituacaoCtcLabel,
      },
      {
        id: 'acoes',
        label: 'Ações',
        dataFormat: this.montaAcoesCTC,
      },
    );
    return tableHeader;
  }

  montaColunasEspecificasVersao = () => (
    [{
      id: 'versaoCtc',
      label: 'Versão',
    }]
  )

  formatarCpf = (cpf) => {
    let retorno = '';
    if (cpf) {
      retorno = cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
    }
    return retorno;
  };

  montaTituloTabela = () => {
    const {
      cpf,
      titulo,
      listaCtcsIndexada,
      estadoConsulta,
      filtrosConsulta,
    } = { ...this.state };
    let complemento = '';

    if (estadoConsulta !== 'inicial' && (filtrosConsulta && (filtrosConsulta.cpf === undefined))) {
      complemento = `encontradas para o cpf ${this.formatarCpf(this.props.auth.userData.prevCpf)} - ${this.props.auth.userData.name}`;
    }
    if (estadoConsulta !== 'inicial' && (filtrosConsulta && (filtrosConsulta.cpf !== undefined)) && listaCtcsIndexada && listaCtcsIndexada.length > 0) {
      complemento = `encontradas para o cpf ${this.formatarCpf(listaCtcsIndexada[0].cpf)} - ${listaCtcsIndexada[0].nome}`;
    }
    if (estadoConsulta !== 'inicial' && (cpf !== undefined) && listaCtcsIndexada && listaCtcsIndexada.length === 0) {
      complemento = `encontradas para o cpf ${this.formatarCpf(cpf)}`;
    }
    const retorno = titulo;
    return `${retorno}${complemento}`;
  }

  defineListaParaTabela = () => {
    if (this.state.listaCtcsFiltrada !== null) {
      return this.state.listaCtcsFiltrada;
    }
    return this.state.listaCtcsIndexada;
  }

  alterarPagina = (pagina, page) => {
    const { estadoTabela } = { ...this.state };
    estadoTabela.paginaAtual = pagina;
    if (pagina === 0) {
      estadoTabela.paginaAtual = 1;
    } else {
      estadoTabela.paginaAtual = pagina;
    }

    if (page) {
      estadoTabela.resultadosPorPagina = page;
    }

    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizaConsulta());
  }

  alterarResultadosPorPagina = (resultadosPorPagina) => {
    const { estadoTabela } = { ...this.state };
    estadoTabela.resultadosPorPagina = resultadosPorPagina;
    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizaConsulta());
  }

  verificarQuantidadeMatriculasEDestinatarios = (ctc) => {
    let retorno = false;
    const temMatricula1 = (ctc.matricula1 !== null && ctc.matricula1 !== VAZIO);
    const temMatricula2 = (ctc.matricula2 !== null && ctc.matricula2 !== VAZIO);

    if (ctc.destinacoes) {
      const tamanhoDestinacoes = ctc.destinacoes.length;
      if (tamanhoDestinacoes === TAMANHO_MAX_COLECAO_COM_DUAS_MATRICULAS) {
        if (temMatricula1 && temMatricula2) {
          retorno = true;
        }
      } else if (tamanhoDestinacoes === TAMANHO_MAX_COLECAO_COM_UMA_MATRICULA) {
        if (temMatricula1 && !temMatricula2) {
          retorno = true;
        }
      }
    }
    return retorno;
  }

  newCadastroCtc = () => {
    const { cpf } = { ...this.state };
    const { filtrosConsulta } = { ...this.state };

    const { listaCtcsIndexada } = { ...this.state };
    let situacao = '';
    let limiteAtingido = false;
    let cpfPesquisa = null;

    if (cpf !== null && cpf !== undefined) {
      cpfPesquisa = cpf;
    }
    if (filtrosConsulta && filtrosConsulta.cpf !== null && filtrosConsulta.cpf !== undefined) {
      cpfPesquisa = filtrosConsulta.cpf;
    }

    if (listaCtcsIndexada && listaCtcsIndexada.length > 0) {
      situacao = this.verificarSituacao(listaCtcsIndexada[0]);
      limiteAtingido = this.verificarQuantidadeMatriculasEDestinatarios(listaCtcsIndexada[0]);
    }

    if (limiteAtingido) {
      trataMensagensErro(['Não é possível adicionar nova CTC. Limite de CTC para este CPF foi atingido.']);
    } else if (situacao === SITUACAO_RASCUNHO) {
      trataMensagensErro(['Não é possível adicionar nova CTC enquanto o rascunho não for salvo em definitivo.']);
    } else if (situacao !== SITUACAO_RASCUNHO && limiteAtingido === false) {
      if (cpfPesquisa) {
        this.props.history.push(`/repositorioctc/rpps/${cpfPesquisa}/novo`);
      }
    }
  }

  handleFechamentoModalAlerta = () => {
    this.setState({
      alertas: [],
      showModalAlerta: !this.state.showModalAlerta,
    });
  }

  handleFechamentoModalInvalidacaoCtc = () => {
    this.setState({
      alertas: [],
      showModalAlertaInvalidacao: !this.state.showModalAlertaInvalidacao,
    });
  }

  exibirModalAlertaRascunho = (row) => {
    this.setState({
      protocoloComprev: row.protocoloComprev,
      alertas: [msgConfirmacaoCtc.apagarRascunhoCtc],
      showModalAlerta: !this.state.showModalAlerta,
    });
  }

  trataSucessoApagarRascunho = () => {
    trataMensagemSucesso(['Rascunho da CTC apagado com sucesso.']);
    this.setState({
      showModalAlerta: !this.state.showModalAlerta,
    });
    this.realizaConsulta();
  }

  trataErrosApagarRascunho = (error) => {
    if (error) {
      trataMensagensErro(['Não foi possível excluir o rascunho da CTC.']);
      this.setState({
        showModalAlerta: !this.state.showModalAlerta,
      });
    }
  }

  exibirModalAlertaInvalidarCtc = (row) => {
    this.setState({
      protocoloComprev: row.protocoloComprev,
      alertas: [msgConfirmacaoCtc.invalidarCtc],
      showModalAlertaInvalidacao: !this.state.showModalAlertaInvalidacao,
    });
  }

  trataSucessoInvalidarCTC = () => {
    trataMensagemSucesso(['CTC invalidada com sucesso.']);
    this.setState({
      showModalAlertaInvalidacao: !this.state.showModalAlertaInvalidacao,
    });
    this.realizaConsulta();
  }

  trataErrosInvalidarCTC = (error) => {
    if (error) {
      trataMensagensErro(['Não foi possível invalidar a CTC.']);
      this.setState({
        showModalAlertaInvalidacao: !this.state.showModalAlertaInvalidacao,
      });
    }
  }

  apagarRascunhoCtc = () => {
    const { protocoloComprev } = { ...this.state };
    const url = 'ctc/deletar-rascunho';
    let options;
    if (this.state.chaveConfirmacao) {
      options = { 'Chave-Confirmacao': this.state.chaveConfirmacao };
    }

    doDelete(
      url,
      protocoloComprev,
      this.trataSucessoApagarRascunho,
      this.trataErrosApagarRascunho,
      options,
    );
  }

  invalidarCtc = () => {
    const { protocoloComprev } = { ...this.state };
    const url = `ctc/invalidacao/${protocoloComprev}`;
    let options;
    if (this.state.chaveConfirmacao) {
      options = { 'Chave-Confirmacao': this.state.chaveConfirmacao };
    }
    doPut(
      url,
      protocoloComprev,
      this.trataSucessoInvalidarCTC,
      this.trataErrosInvalidarCTC,
      options,
    );
  }

  exibirBotaoIncluirCtc = () => {
    let retorno = false;
    const existeCpfPreenchido = (this.state.filtrosConsulta && this.state.filtrosConsulta.cpf !== '' &&
      this.state.filtrosConsulta.cpf !== null && this.state.filtrosConsulta.cpf !== undefined);
    if (this.state.filtrosConsulta && this.state.filtrosConsulta.versaoAtiva === 1 && existeCpfPreenchido) {
      retorno = true;
    }
    return retorno;
  }

  render() {
    const options = {
      noDataText: 'Nenhuma CTC para ser exibida.',
      hideSizePerPage: false,
      onPageChange: this.alterarPagina,
      page: this.state.estadoTabela.paginaAtual,
      sizePerPage: this.state.estadoTabela.resultadosPorPagina,
      sizePerPageList: listUtils.linhasPorPagina,
      // alwaysShowAllBtns: false,
    };
    const fetchInfo = {
      dataTotalSize: this.state.estadoTabela.quantidadeTotalResultados,
    };
    const tableHeader = this.montaColunas();

    let modalAlerta;
    let modalAlertaInvalidacaoCtc;

    if (this.state.showModalAlerta) {
      modalAlerta = (<ModalAlerta
        alertas={this.state.alertas}
        aceitar={this.apagarRascunhoCtc}
        handleModal={this.handleFechamentoModalAlerta}
        showModal
      />);
    }

    if (this.state.showModalAlertaInvalidacao) {
      modalAlertaInvalidacaoCtc = (<ModalAlerta
        alertas={this.state.alertas}
        aceitar={this.invalidarCtc}
        handleModal={this.handleFechamentoModalInvalidacaoCtc}
        showModal
      />);
    }

    return (
      <DtpContentContainer>
        <FiltroRepositorioCtc
          handleSearchFilter={this.realizaConsulta}
          handleChangeList={this.tratarFiltroNaLista}
          handleChange={this.handleChange}
          listaCtcsIndexadaAtualizada={this.state.listaCtcsIndexadaAtualizada}
          auth={this.props.auth}
          tipoConsulta={this.getTipoConsulta()}
        />
        <Table
          legend={this.montaTituloTabela()}
          bordered
          fetchInfo={fetchInfo}
          data={this.state.listaCtcsIndexada}
          options={options}
          listaTableHeader={tableHeader}
          pagination
          remote
        />
        {this.exibirBotaoIncluirCtc() &&
          <DtpButton
            className="dtp-primary right"
            title="Criar CTC / Rascunho"
            accessibilityName="Criar uma nova CTC ou um rascunho"
            hint="Criar uma nova CTC ou um rascunho"
            onClick={() => this.newCadastroCtc()}
          />
        }
        {modalAlerta}
        {modalAlertaInvalidacaoCtc}
      </DtpContentContainer>
    );
  }
}

ConsultaRepositorioCtc.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      protocolo: PropTypes.string,
      tipoConsulta: PropTypes.string,
      regime: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }).isRequired,
  destinatarios: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
};

ConsultaRepositorioCtc.defaultProps = {
  match: null,
  destinatarios: [],
};

const mapStateToProps = state => ({
  destinatarios: state.base.destinatarios,
});

export default connect(mapStateToProps)(ConsultaRepositorioCtc);



// WEBPACK FOOTER //
// ./src/pages/repositorio-ctc/ConsultaRepositorioCtc.jsx